import React from "react";
import ForgotPassword from "../auth/ForgotPassword";

export default function ForgotPasswordPage() {
  return <ForgotPassword />;
}
